import styled from 'styled-components';
import { Breadcrumb as AntdBreadcrumb, Skeleton } from 'antd5';
import { Link } from 'react-router-dom';
import { Theme } from 'utils/color/horizonTheme';

export const Breadcrumb = styled(AntdBreadcrumb)`
  &.ant-breadcrumb {
    ol {
      li {
        color: ${({ theme }) => theme.secondaryTextColor} !important;

        &:has(.ant-skeleton) {
          padding-top: 2px;
        }

        :last-child {
          font-size: 1.25rem;
        }
      }

      .ant-breadcrumb-separator {
        font-size: 1.25rem;
      }

      .ant-breadcrumb-link > a {
        color: ${({ theme }) =>
          theme.themeName === Theme.Dark ? theme.labelColor : 'unset'} !important;
        &:hover {
          background-color: inherit;
          color: ${({ theme }) => theme.teal} !important;
        }
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  font-size: 1.25rem;
`;

export const StyledTitle = styled.span`
  font-size: 1.25rem;
`;

export const StyledSkeleton = styled(Skeleton)`
  &.ant-skeleton {
    display: inline;
    vertical-align: text-top;
  }
  .ant-skeleton-content .ant-skeleton-title {
    margin: 0;
  }
`;
